import Vue from 'vue';

export default {
    SET_SOCKET(state, socket) {
    	if(this.getters.devmode) console.debug('M|SET_SOCKET');
    	state.socket = socket;
    },
    UNSET_SOCKET(state) {
    	if(this.getters.devmode) console.debug('M|UNSET_SOCKET');
        state.socket = false;
    },


    ADD_TO_POOL(state, payload) {
    	if(this.getters.devmode) console.debug('M|ADD_TO_POOL', payload);
    	console.log(state.pool);
    	state.pool.push(payload);
    	console.log(state.pool);
    },

    REMOVE_FROM_POOL(state, index) {
    	if(this.getters.devmode) console.debug('M|REMOVE_FROM_POOL', index);
        state.pool.splice(index, 1);
    },



    ONLINE(state, socket) {
    	if(this.getters.devmode) console.debug('M|ONLINE');
    	state.online = true;
    },
    OFFLINE(state) {
    	if(this.getters.devmode) console.debug('M|OFFLINE');
        state.online = false;
    },

}



// WEBPACK FOOTER //
// ./src/store/socket/mutations.js